













































import Vue from 'vue'
import ProjectServer from '@/models/ProjectServer';
import Project from '../models/Project';
import { DelegateBuilder, IDelegate } from '@/models/DelegateBuilder';
import Mutations from '@/store/mutations'
import ChatRoot from '@/components/chat/ChatRoot.vue'
import SupportForm from '@/components/support/SupportForm.vue';
import { BvModalEvent } from 'bootstrap-vue';
import AFKListener from '@/components/AFKListener.vue'

export default Vue.extend({
	components: {
		ChatRoot,
		SupportForm,
		AfkListener: AFKListener
	},
	data(){
		return {
			openedDelegate: <IDelegate><unknown>null,
			closedDelegate: <IDelegate><unknown>null,
			openUpdateInterval: <any>null,
			modalKey: 0
		}
	},
	/*watch: {
		"$route"() {
			let to = this.$route;
			if (to.meta.isRoot || to.path.toLowerCase() == '/app/project/' || to.path.toLowerCase() == '/app/project')
			{
				this.$router.push('/app/project/timelines');
				return;
			}
		}
	},*/
	methods: {
		supportModalSubmit(modal : BvModalEvent)
		{
			modal.preventDefault();
			this.$nextTick(()=>{
				(this.$refs['supportForm'] as SupportForm).submit();
			})
		},
		projectLoaded() : Boolean
		{
			return this.connected && ProjectServer.instance.projectReady;
		},

		connected() : Boolean
		{
			return ProjectServer.instanceExists && ProjectServer.instance.connected;
		},

		projectConnectionExists() : Boolean
		{
			return ProjectServer.instanceExists;
		},

		connecting() : Boolean
		{
			return (this.projectConnectionExists() && ProjectServer.instance.socket != null) || ProjectServer.instance.IsRequestingAddress;
		}
	},
	beforeRouteEnter(to, from, next)
	{
		console.log("Entering project...")
		console.log(Object.assign({}, ProjectServer.instance))
		if (!
			((
				ProjectServer.instanceExists && ProjectServer.instance.socket != null) ||
				ProjectServer.instance.IsRequestingAddress
			))
		{
			alert("Not connected to a project, returning to dashboard...");
			next('/app/');
			return;
		}
		console.log(`[ENTER] from ${from.path} to ${to.path}`);
		if (to.meta.isRoot || to.path.toLowerCase() == '/app/project/' || to.path.toLowerCase() == '/app/project')
		{
			next('/app/project/timelines');
			return;
		}
		next();
	},
	beforeRouteLeave(to, from, next)
	{
		this.$store.commit(Mutations.resetProjectToDefault);
		console.log(`[LEAVE] from ${from.path} to ${to.path}`);
		if (to.path.toLowerCase().indexOf("/app/project") == -1)
		{
			// TODO: clean up project connection
			ProjectServer.instance.disconnect();
		}
		next();
	},
	mounted()
	{
		if (!this.projectConnectionExists)
		{
			alert("Not connected to a project, returning to dashboard...");
			this.$router.push('/app/');
			return;
		}

		this.openedDelegate = ()=>{
			this.$forceUpdate();
			//alert(`update pls - value == ${this.connected}; ${ProjectServer.instance.connecting}; ${ProjectServer.instance.connected}`);
		}

		this.closedDelegate = ()=>{
			this.$forceUpdate();
			if (this.$route.path.includes("/project/"))
			{
				if (ProjectServer.instance.WasIntentionalClosure)
				{
					this.$router.push('/app/');
				}
				else
				{
					try
					{
						let proj : Project | undefined = this.$store.state.project.project;
						if (proj)
						{
							const target = `/app/reconnect/${proj.id}/3`;//?targetRoute=${encodeURIComponent(this.$route.path)}`;
							this.$router.push(target);
							return;
						}

						throw { error: 'project undefined' };
					}
					catch(er)
					{
						console.error('Failed to reconnect, error below...');
						console.error(er);
						this.$router.push('/app/');
					}
				}
			}
		};
		
		if (!this.projectLoaded())
		{
			this.openUpdateInterval = setInterval(()=>{
				try
				{
					//console.log(`========INTERVAL======: ${this.projectConnectionExists()} && ${ProjectServer.instance.connected} == ${this.connected()}; ${this.projectLoaded()}`);
					this.$forceUpdate();
					if (this.connected() && this.projectLoaded())
					{
						clearInterval(this.openUpdateInterval);
						this.openUpdateInterval = -1;
					}
				}
				catch(err)
				{
					alert(err);
				}
			}, 30);
		}

		ProjectServer.instance.onConnectionOpened.add(this.openedDelegate);
		ProjectServer.instance.onConnectionClosed.add(this.closedDelegate);
	},
	beforeDestroy()
	{
		if (this.openUpdateInterval != -1)
		{
			clearInterval(this.openUpdateInterval);
			this.openUpdateInterval = -1;
		}
		ProjectServer.instance.onConnectionOpened.remove(this.openedDelegate);
		ProjectServer.instance.onConnectionClosed.remove(this.closedDelegate);
	}
})
